import { render } from "./OrdersFilter.vue?vue&type=template&id=fd94481e&ts=true"
import script from "./OrdersFilter.vue?vue&type=script&lang=ts"
export * from "./OrdersFilter.vue?vue&type=script&lang=ts"

import "./OrdersFilter.vue?vue&type=style&index=0&id=fd94481e&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__